import { Button, Col, Row } from 'react-bootstrap';
// import IconAparmentRent from '../assets/new-icons/undraw_apartment-rent_oodr.svg';
import { useTranslation } from 'react-i18next';

function CustomErrorFallback({ error, eventId, resetError }) {
  const { t } = useTranslation();

  // console.log(error.message)

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="vh-100">
      <div className="h-100 d-flex flex-column container-fluid">
        <div className="flex-grow-1 d-flex align-items-xs-end align-items-sm-center align-items-md-center  align-items-center justify-content-center">
          <div className="error-fallback text-center">
            <p className="mb-0 app-fs-h4 app-lh-h app-fw-notosans-bold app-txt-granite">
              {t('TXT_ERROR_BOUNDARY_TITLE')}
            </p>

            <p className="mb-2 app-txt-gray mt-2 app-fs-18">
              {t('TXT_ERROR_BOUNDARY_SUBTITLE')}
            </p>

            {error.message !== '' && <small className="app-fs-12">{t(error.message)}</small>}

            <div className="image-error__boundary mt-4 mx-auto" />
            {/* <img src={IconAparmentRent} alt="IconAparmentRent" className="img-fluid" /> */}

            <Row className="mt-4">
              <Col xs={12} md={6} lg={6} className="text-md-end text-center mb-3">
                <Button variant="" className="border-0 app-bg-granite-80-light py-3 btn-refresh" onClick={() => handleReload()}>
                  <span className="ps-1 app-txt-granite-80-dark app-fw-notosans-bold align-middle">
                    {t('TXT_ERROR_BOUNDARY_BTN_REFRESH')}
                  </span>
                </Button>
              </Col>
              <Col xs={12} md={6} lg={6} className="text-md-start text-center">
                <Button variant="" className="border-0 app-bg-sand py-3 btn-reset-app" onClick={() => handleGoHome()}>
                  <span className="ps-1 app-txt-granite-80-dark app-fw-notosans-bold align-middle">
                    {t('TXT_ERROR_BOUNDARY_BTN_RESET_APP')}
                  </span>
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomErrorFallback;
